import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_ITEMCATEGORY_INIT_ACTION,
  FETCH_ITEMCATEGORY_SUCCESS_ACTION,
  FETCH_ITEMCATEGORY_FAIL_ACTION,
  ADD_ITEMCATEGORY_INIT_ACTION,
  ADD_ITEMCATEGORY_SUCCESS_ACTION,
  ADD_ITEMCATEGORY_FAIL_ACTION,
  EDIT_ITEMCATEGORY_INIT_ACTION,
  EDIT_ITEMCATEGORY_SUCCESS_ACTION,
  EDIT_ITEMCATEGORY_FAIL_ACTION,
  DELETE_ITEMCATEGORY_INIT_ACTION,
  DELETE_ITEMCATEGORY_SUCCESS_ACTION,
  DELETE_ITEMCATEGORY_FAIL_ACTION
} from "./action";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchitemCategorylist(value) {
  // console.log(value);
  let pageno = value.value === undefined ? 1 : value.value;
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(
      `${appConfig.ip}/itemCategory?limit=10&page=` + pageno,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_ITEMCATEGORY_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_ITEMCATEGORY_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* AddItemCategory(value) {
  // console.log(value);
  try {
    const token = localStorage.getItem("token");

    const data = {
      name: value.value.itemCategory,
      disc: value.value.itemCategoryDescp,
      isActive: value.value.isActive
    };

    const res = yield fetch(`${appConfig.ip}/itemCategory`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({ type: FETCH_ITEMCATEGORY_INIT_ACTION });
      yield put({
        type: ADD_ITEMCATEGORY_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Item Category added successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: ADD_ITEMCATEGORY_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* EditItemCategory(value) {
  try {
    const token = localStorage.getItem("token");

    const data = {
      name: value.value.itemCategory,
      disc: value.value.itemCategoryDescp
    };

    const res = yield fetch(`${appConfig.ip}/itemCategory/` + value.value.id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
    } else {
      const resJSON = yield res.json();

      yield put({ type: FETCH_ITEMCATEGORY_INIT_ACTION });
      yield put({
        type: EDIT_ITEMCATEGORY_SUCCESS_ACTION,
        payload: resJSON
      });
      yield toast.success("Item Category updated successfully", {
        autoClose: 3000
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: EDIT_ITEMCATEGORY_FAIL_ACTION,
        error: err
      });
    }
  }
}

function* DeleteItemCategory(value) {
  let id = value.value;
  // let data = {
  //   isActive: false
  // };

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/itemCategory/` + id, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify()
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: FETCH_ITEMCATEGORY_INIT_ACTION });
      yield toast.success("Deleted successfully", {
        autoClose: 3000
      });

      yield put({
        type: DELETE_ITEMCATEGORY_SUCCESS_ACTION
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: DELETE_ITEMCATEGORY_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* ItemCategoryActionWatcher() {
  yield takeEvery(FETCH_ITEMCATEGORY_INIT_ACTION, fetchitemCategorylist);
  yield takeEvery(ADD_ITEMCATEGORY_INIT_ACTION, AddItemCategory);
  yield takeEvery(EDIT_ITEMCATEGORY_INIT_ACTION, EditItemCategory);
  yield takeEvery(DELETE_ITEMCATEGORY_INIT_ACTION, DeleteItemCategory);
}
